var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "All mutualfunds"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 843780
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3342",
    d: "M27.62 20.41h-1.338a4.192 4.192 0 00-.564-1.308h1.9a1.007 1.007 0 10.01-2.013h-7.8a1.006 1.006 0 100 2.013h2.234a2.284 2.284 0 012.113 1.308h-4.347a1.006 1.006 0 100 2.013h4.347a3.157 3.157 0 01-.453.634 2.364 2.364 0 01-1.65.674h-2.234a1.022 1.022 0 00-1.006 1.036 1.039 1.039 0 00.312.725l5.575 5.283a1.003 1.003 0 001.409-1.429l-.03-.03-3.753-3.552a4.3 4.3 0 002.787-1.268 4.254 4.254 0 001.157-2.073h1.328a1.006 1.006 0 000-2.013z",
    fill: "#97144d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1470"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1469"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3343",
    d: "M45.26 25.18l-4.629-6.752a1 1 0 00-.825-.433.99.99 0 00-.825.433l-4.639 6.732a1.017 1.017 0 00.262 1.409 1.04 1.04 0 00.564.181h3.371a14.693 14.693 0 01-5.273 8.725 15.535 15.535 0 01-9.58 3.562 15.869 15.869 0 01-12.075-6.128 1.008 1.008 0 00-1.62 1.2.139.139 0 01.03.04 17.706 17.706 0 0013.665 6.913 17.526 17.526 0 0010.847-4.017 16.738 16.738 0 006.038-10.284h3.864a1.011 1.011 0 001.006-1.016.941.941 0 00-.181-.565z",
    fill: "#6d6e71"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1471"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3344",
    d: "M37.462 12.95a.139.139 0 01-.03-.04A17.706 17.706 0 0023.766 6a17.526 17.526 0 00-10.848 4.015A16.756 16.756 0 006.87 20.309H3.006A1.011 1.011 0 002 21.326a.941.941 0 00.181.564l4.649 6.731a1 1 0 00.825.433.99.99 0 00.825-.433l4.639-6.732a1.011 1.011 0 00-.835-1.58H8.913a14.693 14.693 0 015.273-8.725 15.535 15.535 0 019.58-3.562 15.869 15.869 0 0112.075 6.128 1.008 1.008 0 001.62-1.2z",
    fill: "#6d6e71"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 131",
    fill: "#97144d",
    stroke: "#f6f7f8",
    strokeWidth: 2,
    transform: "translate(32 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon / Done / Black",
    d: "M41.739 17.087l-2.792-2.792-.947.947 3.739 3.739 8.034-8.034-.947-.947z",
    fill: "#fff"
  }))));
}
export default SvgSwitchSuccess;